<template>
    <div class="hand" v-if="!isPhone">
        <div class="lefimg">
            <img :src="webDate.logo" alt="logo" v-if="webDate">
        </div>
        <div class="rigtext">
            <div class="item" v-for="(item, index) in state.headlist" :key="index">
                <div @click="Jump(item, index)" v-if="item.list.length <= 0">
                    <span class="route_name" :class="{ 'active': item.active }">{{ item.name }}</span>
                </div>

                <el-popover placement="bottom" :width="183" trigger="hover" popper-class='popperClass_box' v-else>
                    <template #reference>
                        <div style="display:flex;align-items:center;">
                            <span class="route_name" :class="{ 'active': item.active }">{{ item.name }}</span>
                            <el-icon :size="16" :color="item.active ? '#ff4817' : '#ffffff'" style="margin-left:5px;">
                                <ArrowDown />
                            </el-icon>
                        </div>
                    </template>
                    <div class="popover_box">
                        <span v-for="(list, listIndex) in item.list" :key="listIndex" class="list_name" :class="{ 'listName_active': list.active }" @click="Jump(list, index)">{{ list.liname
                            }}</span>
                    </div>
                </el-popover>
            </div>
        </div>
    </div>

    <div class="phone_head" v-else>
        <div></div>
        <img :src="webDate.logo" alt="logo" class="phone_logo" v-if="webDate">
        <img src="../assets/phone_more.png" class="more" @click="showLeft = true" alt="">
    </div>

    <popup v-model:show="showLeft" position="left" :style="{ width: '20.88rem', height: '100%', background: 'rgba(2, 77, 116,0.6)' }">
        <div class="pop_logobox">
            <img :src="company.companyLogo" class="pop_logo" alt="">
        </div>

        <div class="menu_box">
            <div class="menu_item" v-for="item in PhoneState.headlist" :key="item.name" @click="Jump(item, index)">
                <span>{{ item.name }}</span>
                <van-icon name="arrow" class="Icon" />
            </div>
        </div>
    </popup>

</template>

<script setup>
import { reactive, defineEmits, watch, computed, ref } from "vue";
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { Popup, Icon as vanIcon } from 'vant';
import { getHomeConfig } from '@/api/home/index.js'
const showLeft = ref(false);
const store = useStore()
const webDate = computed(() => store.state.webDate);
let state = reactive({
    headlist: [
        {
            name: '首页',
            path: '/',
            show: false,
            active: false,
            list: []
        },

        {
            name: '饰面设计',
            path: '/product',
            show: false,
            active: false,
            list: []
        },
        {
            name: '品牌授权',
            path: '/cooperation',
            show: false,
            active: false,
            list: []
        },

        {
            name: '关于品牌',
            path: '/aboutUs',
            show: false,
            active: false,
            list: []
        },
        {
            name: '品质证书',
            path: '/certificate',
            show: false,
            active: false,
            list: []
        },

        {
            name: '联系我们',
            path: '/contactUs',
            show: false,
            active: false,
            list: []
        },

        // {
        //     name: '关于我们',
        //     path: '/aboutUs',
        //     show: false,
        //     active: false,
        //     list: []
        // },
    ],
})
const emit = defineEmits(['cooperative']);
let headlistIndex = 0;
let router = useRouter()
const Jump = (item, index) => {
    if (item.path) {
        router.push(item.path)
    }
    headlistIndex = index;
    showLeft.value = false;
}

const company = ref({})
const getCompany = () => {
    getHomeConfig({ type: 2 }).then(res => {
        if (res.code == 0) {
            if (res.data && res.data.context) {
                company.value = JSON.parse(res.data.context);
            }

        }
    })
}

getCompany();



// 移动端
const isPhone = ref(false);
let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
if (flag) {
    isPhone.value = true;
}

let PhoneState = reactive({
    headlist: [
        {
            name: '首页',
            path: '/',
            show: false,
            active: false,
            list: []
        },

        {
            name: '饰面设计',
            path: '/Phone/product',
            show: false,
            active: false,
            list: []
        },
        {
            name: '品牌授权',
            path: '/Phone/cooperation',
            show: false,
            active: false,
            list: []
        },
        {
            name: '关于品牌',
            path: '/Phone/aboutUs',
            show: false,
            active: false,
            list: []
        },

        {
            name: '品质证书',
            path: '/Phone/certificate',
            show: false,
            active: false,
            list: []
        },


        {
            name: '联系我们',
            path: '/Phone/contactUs',
            show: false,
            active: false,
            list: []
        },

        // {
        //     name: '关于我们',
        //     path: '/Phone/aboutUs',
        //     show: false,
        //     active: false,
        //     list: []
        // },
    ],
})



watch(() =>
    router.currentRoute.value.path,
    (toPath) => {
        state.headlist.forEach(item => {
            item.active = item.path === toPath ? true : false;
            item.list.forEach(val => {
                val.active = val.path === toPath ? true : false;
            })
        })
        if (headlistIndex == 2 || headlistIndex == 7) {
            state.headlist[headlistIndex].active = true;
        }
    },
    { immediate: true, deep: true }
)

// window.onscroll = () => {
//     console.log(document.body.scrollTop);
//     if (document.body.scrollTop > 200) {

//         document.querySelector('.hand').style.height = '68px'
//     } else {
//         document.querySelector('.hand').style.height = '88px'
//     }
// }
</script>

<style scoped lang='scss'>
.hand {
    width: 100%;
    min-width: 1920px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    padding: 0px 125px;
    height: 87px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    .lefimg {
        width: 239px;

        img {
            width: 239px;
        }
    }

    .rigtext {
        display: flex;

        .item {
            // width: 100px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            color: #4b4b4b;
            margin-right: 50px;
            border-radius: 4px;
            position: relative;

            .route_name {
                display: block;
                font-size: 16px;
                color: #4b4b4b;
                font-style: normal;
                cursor: pointer;

                &:hover {
                    color: #4b4b4b;
                    font-size: 17px;
                }
            }
        }
    }
}

.active {
    color: #024d74 !important;
    position: relative;

    &::after {
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        content: "";
        display: block;
        width: 77px;
        height: 4px;
        background: #024d74;
        border-radius: 5px;
    }
}
</style>

<style lang='scss'>
.popperClass_box {
    background: #05071e !important;
    border: none !important;
}

.popperClass_box .el-popper__arrow::before {
    background: #05071e !important;
    border: none !important;
}

.popover_box {
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
}

.list_name {
    font-size: 16px;
    color: #ffffff;
    font-style: normal;
    cursor: pointer;
    text-align: center;
    width: 100%;
    height: 50px;
    line-height: 50px;

    &:hover {
        color: #ff4817;
        font-size: 17px;
    }
}

.listName_active {
    color: #ff4817 !important;
    position: relative;
}

.phone_head {
    width: 100vw;
    background: #ffffff;
    height: 6.25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.75rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;

    .phone_logo {
        width: 14.94rem;
        height: 3.44rem;
    }

    .more {
        width: 2.63rem;
        height: 2.19rem;
    }
}

.pop_logobox {
    width: 100%;
    height: 6.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #ededed;

    .pop_logo {
        width: 14.94rem;
        height: 3.44rem;
    }
}

.menu_box {
    width: 100%;

    .menu_item {
        width: 100%;
        height: 6.25rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 1.81rem;
        border-bottom: 1px solid #ededed;

        span {
            font-size: 1.88rem;
            color: #ffffff;
        }

        .Icon {
            font-size: 1.88rem;
            color: #ffffff;
        }
    }
}
</style>